/**
 * 메타데이터 섹션 컴포넌트
 * ServiceDetailDialog에서 분리
 */
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface MetadataSectionProps {
  metadata?: Record<string, any>;
  excludeKeys?: string[];
}

export const MetadataSection: React.FC<MetadataSectionProps> = ({
  metadata,
  excludeKeys = ['pricing_plans', 'subscription'],
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // 제외할 키들을 필터링
  const filteredMetadata = metadata ? { ...metadata } : {};
  excludeKeys.forEach(key => delete filteredMetadata[key]);

  const hasContent = Object.keys(filteredMetadata).length > 0;

  if (!hasContent) {
    return (
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-2">추가 정보</h3>
        <div className="bg-gray-50 border border-gray-200 rounded-md p-4">
          <p className="text-sm text-gray-500">추가 정보가 없습니다.</p>
        </div>
      </div>
    );
  }

  const jsonString = JSON.stringify(filteredMetadata, null, 2);

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold text-gray-700">추가 정보</h3>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-sm text-gray-600 hover:text-gray-800 flex items-center gap-1"
        >
          {isExpanded ? (
            <>
              <ChevronUp className="h-4 w-4" />
              <span className="text-xs">접기</span>
            </>
          ) : (
            <>
              <ChevronDown className="h-4 w-4" />
              <span className="text-xs">펼치기</span>
            </>
          )}
        </button>
      </div>
      {isExpanded && (
        <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
          <pre className="text-xs text-gray-600 whitespace-pre-wrap">
            {jsonString}
          </pre>
        </div>
      )}
    </div>
  );
};

export default MetadataSection;
